import type {
  SavingsMarketProduct,
  SavingsMarketProductPayload
} from '@interfaces/Savings.interface';
import {
  SAVINGS_API_VERSION_HEADERS,
  SavingsReferenceResourceClient
} from '../savings-reference-resource';

export class ApiSavingsMarketProducts extends SavingsReferenceResourceClient<
  SavingsMarketProduct,
  SavingsMarketProductPayload
> {
  protected readonly path = '/savings-market-products';
  protected readonly searchFilter = 'product_structured';

  async get(id: number): Promise<SavingsMarketProduct> {
    const res = await this.client.get(`${this.path}/${id}`, {
      headers: SAVINGS_API_VERSION_HEADERS
    });
    return res.data.data;
  }
}

export { savingsMarketProductsQueryKeys } from './query-keys';
export {
  useSavingsMarketProductQuery,
  useSavingsMarketProductsListQuery
} from './use-savings-market-products-queries';
export {
  useSavingsMarketProductsCreateMutation,
  useSavingsMarketProductsDeleteMutation,
  useSavingsMarketProductsUpdateMutation
} from './use-savings-market-products-mutations';
export type { SavingsMarketProductsUpdateVariables } from './use-savings-market-products-mutations';
